module.exports = __webpack_public_path__ + "media/audio-click.85e1067d.mp3";